import { useQuery } from 'react-query';
import { REQUEST_ACTIONS } from '~/Constants/Actions.constants';
import { EVENT_SERVICE_URLS } from '~/Constants/Urls.constants';
import { requestReactQuery } from '~/Helpers/ReactQuery.helper';
import { useProvider } from '~/Hooks';
import { IErrorResponse } from '~/Models/DTO/Error.models';
import { EventType, IEvent } from '~/Models/DTO/Event.model';
import { EventCategory } from '~/Models/DTO/EventCategory.model';

interface IEventListParams {
  providerId?: string;
  eventGroupId?: string;
  trainerId?: string[];
  locationIds?: string[];
  from?: string;
  to?: string;
  types?: EventType[];
  categoryTypes?: EventCategory[];
  waitingListEnabled?: boolean;
  livestream?: boolean;
  archived?: boolean;
  cancelled?: boolean;
  page?: number;
  size?: number;
}

export const useRequestEvents = (params: IEventListParams) => {
  const { currentProvider } = useProvider();

  return useQuery<IEvent[], IErrorResponse>(
    [REQUEST_ACTIONS.GET_EVENT_LIST, params, currentProvider?.uuid],
    () =>
      requestReactQuery<IEvent[]>({
        url: EVENT_SERVICE_URLS.EVENT_LIST,
        config: { method: 'GET' },
        params: {
          ProviderId: currentProvider?.uuid,
          ...params,
        },
      }),
    {
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      refetchOnMount: true,
      initialData: [],
    },
  );
};
